<template>
    <v-content class="boxItIn">
        <div v-for="(log, index) in filteredLogText" :key="index">
            <span v-if="log.indexOf('Successful connection') !== -1" class="textSuccess">{{log}}</span>
            <span v-else-if="log.indexOf('Error:') !== -1" class="textError">{{log}}</span>
            <span v-else class="textNormal">{{log}}</span>
        </div>
    </v-content>
</template>

<script>
    const fb = require('../firebase')

    export default {
        name: "Log",
        props: ['serial'],
        data () {
            return {
                logText: []
            }
        },
        computed: {
          filteredLogText: function () {
              let filteredLog = []
              this.logText.forEach((logText) => {
                  if (logText.includes(this.serial)) {
                      filteredLog.push(logText)
                  }
              })
              if (filteredLog.length < 1) {
                  filteredLog = ['No cloud log data available for device']
              }
              return filteredLog
          }
        },
        mounted: function () {
            let that = this
            fb.logCollection
                .orderBy('timestamp', 'desc')

                .limit(2500)
                .onSnapshot(function (querySnapshot) {
                    that.logText = []

                    querySnapshot.forEach(function (doc) {
                        let dt = doc.data().timestamp.seconds

                        let date = new Date(dt * 1000)

                        // Hours part from the timestamp
                        // let hours = date.getHours()
                        // Minutes part from the timestamp
                        // let minutes = '0' + date.getMinutes()
                        // Seconds part from the timestamp
                        // let seconds = '0' + date.getSeconds()

                        // Will display time in 10:30:23 format
                        // let formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)

                        that.logText.push(date + ' ' + doc.data().text)
                    })
                })
        }
    }
</script>

<style scoped>
    .textNormal {
        font-family: "Courier New", Arial, serif;
        font-size: 12pt;
        margin: 5pt;
        color: #37474f;
    }
    .textSuccess {
        font-family: "Courier New", Arial, serif;
        font-size: 12pt;
        margin: 5pt;
        color: #000000;
    }
    .textError {
        font-family: "Courier New", Arial, serif;
        font-size: 12pt;
        margin: 5pt;
        color: #9c2900;
    }
    .boxItIn {
        margin: 20px
    }
</style>
